var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a93288a725ac3d3d2cccfb907f79f0a7beab3d1e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gassan@reversed-digital"]={id:"a93288a725ac3d3d2cccfb907f79f0a7beab3d1e"};
      